// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__388DV","header":"MessagesList_header__3Am1m","chat":"MessagesList_chat__26CW8"};